$(document).ready(function () {

    const majorLI = $(".majorli");


    const FAQt_a = document.getElementsByClassName('menuwithchild');
for (let i = 0; i < FAQt_a.length; i++) {
    FAQt_a[i].addEventListener('click', function() {
        let accordionContent = this.lastElementChild;
        if (accordionContent.style.maxHeight) {
            accordionContent.style.maxHeight = null;
        }
         else {
            accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
        }
    });
};
    
    $(".menuwithchild").click(function () {
        $(this).find(".plus2").toggleClass("plus2T");
    }); 

    //--------Nav pre select code------------------

    const pageURL = document.URL.split("/").pop().replace(/-/g, " ").toLowerCase();
    const secondLast = document.URL.split("/").reverse()[1].toLowerCase();
    console.log(secondLast);
    const lastLast = document.URL.split("/").reverse()[0].replace(/-/g, " ").toLowerCase();
    console.log(lastLast);
    const microLIA = $(".minortxt");
    var topMENU = $(".horimenuP");
    if (secondLast != "collections") {
        
        for (let i = 0; i < topMENU.length; i++) {
            if ($(topMENU[i]).text().toLowerCase() == secondLast) {
                $(topMENU[i]).attr('style', 'font-family: "Euclid Circular A" !important');
                $(topMENU[i]).siblings().attr('style', 'font-family: "EuclidCircularALight" !important');
                const topMENUindex = $(topMENU[i]).index();
                for (let i = 0; i < majorLI.length; i++) {
                    var preselect_majorLIval = majorLI[topMENUindex];
                    $(preselect_majorLIval).css("display","block");
                    $(preselect_majorLIval).siblings().css("display","none");
                    };
                        const levelonemenu = $(preselect_majorLIval).find(".dropdown-child").find(".menunochild").find(".minortxt");
                        const levelonesubsubmenu = $(preselect_majorLIval).find(".dropdown-child").find(".menuwithchild").find(".dropdown-grandchild").find(".menu-link").find(".nenotxt");
                        if (levelonemenu) {
                            for (let j = 0; j < levelonemenu.length; j++) {
                                console.log($(levelonemenu[j]).text());
                                if ($(levelonemenu[j]).text().toLowerCase() == lastLast) {
                                 $(levelonemenu[j]).attr('style', 'font-family: "Euclid Circular A" !important');
                                }
                                 
                             }
                        }  
                        if(levelonesubsubmenu) {
                            for (let m = 0; m < levelonesubsubmenu.length; m++) { 
                                if ($(levelonesubsubmenu[m]).text().toLowerCase() == lastLast) {
                                    $(levelonesubsubmenu[m]).attr('style', 'font-family: "Euclid Circular A" !important');
                                    const nenoheight = $(levelonesubsubmenu[m]).parent().parent().prop('scrollHeight') + "px";
                                    $(levelonesubsubmenu[m]).parent().parent().css("max-height", nenoheight);
                                   }
                             }
                        }         
                    }
                }
        }else if(secondLast == "collections") {
            if (navV) {
            for (let j = 0; j < topMENU.length; j++) {
                if ($(topMENU[j]).text().toLowerCase() == navV) {
                    $(topMENU[j]).attr('style', 'font-family: "Euclid Circular A" !important');
                    $(topMENU[j]).siblings().attr('style', 'font-family: "EuclidCircularALight" !important');
                    const topMENUindexCOLL = $(topMENU[j]).index();
                    for (let k = 0; k < majorLI.length; k++) {
                        var preselect_majorLIval = majorLI[topMENUindexCOLL];
                        $(preselect_majorLIval).css("display","block");
                        $(preselect_majorLIval).siblings().css("display","none");
                        };
                        const leveltwomenu = $(preselect_majorLIval).find(".dropdown-child").find(".menunochild").find(".minortxt");
                        const leveltwosubmenu = $(preselect_majorLIval).find(".dropdown-child").find(".menuwithchild").find(".dropdown-grandchild").find(".menu-link").find(".nenotxt");
                        if (leveltwomenu) {
                            for (let l = 0; l < leveltwomenu.length; l++) {
                                if ($(leveltwomenu[l]).text().toLowerCase() == lastLast) {
                                 $(leveltwomenu[l]).attr('style', 'font-family: "Euclid Circular A" !important');
                                }
                                 
                             }
                        }
                        if(leveltwosubmenu) {
                            for (let m = 0; m < leveltwosubmenu.length; m++) { 
                                if ($(leveltwosubmenu[m]).text().toLowerCase() == lastLast) {
                                    $(leveltwosubmenu[m]).attr('style', 'font-family: "Euclid Circular A" !important');
                                    const nenoheight = $(leveltwosubmenu[m]).parent().parent().prop('scrollHeight') + "px";
                                    $(leveltwosubmenu[m]).parent().parent().css("max-height", nenoheight);
                                   }
                             }
                        }
       
                } 
                 
            }
        }
        }
        if(secondLast == "pages") {
            const infoTEXT = $(".infotxt");
            for (let n = 0; n < infoTEXT.length; n++) {
                console.log(infoTEXT[n]);
                if ($(infoTEXT[n]).text().toLowerCase() == lastLast) {
                    $(infoTEXT[n]).attr('style', 'font-family: "Euclid Circular A" !important');
                    const infoulH = $(infoTEXT[n]).parent().parent().prop('scrollHeight') + "px";
                    console.log(infoulH);
                    $(infoTEXT[n]).parent().parent().css("max-height",infoulH); 
                    $(infoTEXT[n]).parent().parent().parent().attr('style', 'font-family: "Euclid Circular A" !important');
                }
                
            }
        }

    //---------Nav pre select code end-------------

    $(".horimenuP").on("click", function () {
        const horimenuINDEX = $(this).index();
        //$(this).css({"text-decoration":"underline 2px #e67d5e","text-underline-offset":"4px","letter-spacing":"1px"});
        $(this).attr('style', 'font-family: "Euclid Circular A" !important');
        $(this).siblings().attr('style', 'font-family: "EuclidCircularALight" !important');
        for (let i = 0; i < majorLI.length; i++) {
        const majorLIval = majorLI[horimenuINDEX];
        $(majorLIval).css("display","block");
        $(majorLIval).siblings().css("display","none");
        }
    });

   
    
     $(".menucon").on("click", function () {
    $(".navmain").css("transform", "translateX(0)");
});

// Close when clicking on close icon
$(".layout__sidebar-close-icon").on("click", function () {
    $(".navmain").css("transform", "translateX(-650px)");
});

// Close when clicking outside navmain
$(document).on("click", function (e) {
    if (!$(e.target).closest(".navmain, .menucon").length) {
        $(".navmain").css("transform", "translateX(-650px)");
    }
});

});

const mainHead = document.getElementById("mainheader");

const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        console.log(entry.isIntersecting);
        if (!entry.isIntersecting) {
            $(".custstickheadermain").addClass("stickydown");
        }else{
            $(".custstickheadermain").removeClass("stickydown");
        }
    })

},{
    rootMargin: "120px"
});

observer.observe(mainHead);


